var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-outer"},[_c('div',{staticClass:"empty-inner"},[_c('svg',{staticClass:"empty"},[_c('use',{attrs:{"xlink:href":require('@/assets/img/icons/alert-circle.svg') + '#layer'}})]),_c('div',{staticClass:"empty-text",domProps:{"innerHTML":_vm._s(_vm.msg != '' ? _vm.$t(_vm.msg) : '')}}),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }